import React from 'react';
import { Divider } from '@chakra-ui/react';
import { FlexCard } from '@codametrix/ui-components';
import { QueueCardRow1, QueueCardRow1Props } from './QueueCardRow1';
import { QueueCardRow2, QueueCardRow2Props } from './QueueCardRow2';
import { QueueStatus } from '../status-badge/StatusBadge';
import './QueueCard.scss';

export interface QueueCardProps {
  priority: number;
  queueName: string;
  description: string;
  status: QueueStatus;
  totalInQueue: number;
  criticalAged: number;
  coderCount: number;
  onDragStart?: (e: React.DragEvent<HTMLSpanElement>) => void;
  isDragging?: boolean;
  onManageCoders?: () => void;
  onHealthTargets?: () => void;
  onForecasting?: () => void;
  className?: string;
}

export const QueueCard: React.FC<QueueCardProps> = ({
  priority,
  queueName,
  description,
  status,
  totalInQueue,
  criticalAged,
  coderCount,
  onDragStart,
  isDragging = false,
  onManageCoders,
  onHealthTargets,
  onForecasting,
  className = ''
}) => {
  const row1Props: QueueCardRow1Props = {
    priority,
    queueName,
    description,
    status,
    totalInQueue,
    criticalAged,
    onDragStart,
    isDragging
  };

  const row2Props: QueueCardRow2Props = {
    coderCount,
    onManageCoders,
    onHealthTargets,
    onForecasting
  };

  return (
    <div className={`cmx-queue-card ${className}`.trim()} data-testid="queue-card">
      <FlexCard overflow="hidden">
        <QueueCardRow1 {...row1Props} />
        <Divider className="cmx-queue-card__divider" />
        <QueueCardRow2 {...row2Props} />
      </FlexCard>
    </div>
  );
};

QueueCard.displayName = 'QueueCard';
export default QueueCard;
